import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

class AlertModal extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleHide = this.handleHide.bind(this);

        this.state = {
            show: this.props.show,
        };
    }

    handleHide() {
        this.props.onHideClick();
    }

    render() {
        return (
            <Modal
                open={this.props.show}
                onClose={this.handleHide}
                size="small"
                aria-labelledby="gtfs-alert-title"
            >
                <Modal.Header id="gtfs-alert-title">{this.props.title}</Modal.Header>
                <Modal.Content>{this.props.text}</Modal.Content>
                <Modal.Actions>
                    <Button primary onClick={this.handleHide}>OK</Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default AlertModal;

